var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.countrys),function(country){return _c('span',{key:country.code,class:['country-item', 'ellipsis', {active: _vm.active === country.code}],on:{"click":() => _vm.handleCountryItem(country)}},[_vm._v(_vm._s(country.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }